const regex = /^[a-z,0-9,-]{36,36}$/

export const validateUUID = (value: string): boolean => regex.test(value)
